import TerminalsDataTable from "../../../components/dataTable/tables/TerminalsDataTable";
import { StyledFlexColumn, StyledFlexRow } from "../../../styles/LayoutStyles";
import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../context/LanguageContext";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import { StyledRoundedOverflowXWrapper } from "../../../styles/WrapperStyles";
import { faPen, faSignIn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  StyledAltButton,
  StyledAltIconButton,
  StyledButton,
} from "../../../styles/ButtonStyles";
import { useAuthContext } from "../../../context/AuthContext";
import PasswordResetInput from "../../password_reset/input/PasswordResetInput";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import { StyledInput } from "../../../styles/InputStyles";
import HiddenLoader from "../../../components/loader/HiddenLoader/HiddenLoader";

function TerminalsPageView({
  terminalUser,
  editData,
  setEditData,
  onCancelEdit,
  onConfirmEdit,
  submitError,
}) {
  const authContext = useAuthContext();
  const { translate } = useLanguageContext();
  const theme = useTheme();

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
      <OverlayLoader groups="terminals_page_user_fetch">
        <StyledRoundedOverflowXWrapper>
          <table>
            <thead>
              <tr>
                <th>
                  {!editData.editing
                    ? translate("eva.main.validation.attributes.email")
                    : translate("eva.main.entities.states.edit", [
                        {
                          key: "entities",
                          value: translate("eva.main.entities.user"),
                        },
                      ])}
                </th>
                {!editData.editing && <th></th>}
              </tr>
            </thead>
            <tbody>
              <tr data-highlight-hover={false}>
                <td>
                  {!editData.editing && terminalUser?.email}

                  {editData.editing && (
                    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
                      <InputWrapper
                        label={translate(
                          "eva.main.validation.attributes.email",
                        )}
                      >
                        <StyledInput
                          type="email"
                          id="email"
                          name="email"
                          value={terminalUser?.email}
                          disabled
                        />
                      </InputWrapper>

                      <PasswordResetInput
                        data={editData}
                        setData={setEditData}
                        submitError={submitError}
                        style={{ width: "100%" }}
                      />

                      <StyledFlexRow>
                        <StyledAltButton onClick={onCancelEdit}>
                          {translate("eva.main.general.cancel")}
                        </StyledAltButton>

                        <HiddenLoader groups={"terminals_page_submit"}>
                          <StyledButton onClick={onConfirmEdit}>
                            {translate("eva.main.general.confirm")}
                          </StyledButton>
                        </HiddenLoader>
                      </StyledFlexRow>
                    </StyledFlexColumn>
                  )}
                </td>

                {!editData.editing && (
                  <td style={{ width: 0 }}>
                    <StyledFlexRow
                      $preventChildStyling
                      style={{ gap: theme.spacing.small, flexWrap: "nowrap" }}
                    >
                      {/* Edit button */}
                      <StyledAltIconButton
                        onClick={() =>
                          setEditData({ ...editData, editing: true })
                        }
                        title={translate("eva.main.entities.states.edit", [
                          {
                            key: "entities",
                            value: translate("eva.main.entities.user"),
                          },
                        ])}
                        disabled={
                          !authContext.hasPermission("terminals.update")
                        }
                      >
                        <FontAwesomeIcon icon={faPen} />
                      </StyledAltIconButton>

                      {/* Sign in button */}
                      {authContext.auth.user.role_type === "superadmin" &&
                        !editData.editing && (
                          <StyledAltIconButton
                            onClick={() =>
                              authContext.switchToUser(terminalUser?.id)
                            }
                            title={translate("eva.main.auth.switch_user.label")}
                          >
                            <FontAwesomeIcon icon={faSignIn} />
                          </StyledAltIconButton>
                        )}
                    </StyledFlexRow>
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        </StyledRoundedOverflowXWrapper>
      </OverlayLoader>

      <TerminalsDataTable />
    </StyledFlexColumn>
  );
}

export default TerminalsPageView;
